import { energyAnalysisApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['Basic Energy - Data', 'Energy Data'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      extractDataBasicEnergyDataAnalysisTypeAccountIdGet: build.query<
        ExtractDataBasicEnergyDataAnalysisTypeAccountIdGetApiResponse,
        ExtractDataBasicEnergyDataAnalysisTypeAccountIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/basic_energy/data/${queryArg.analysisType}/${queryArg.accountId}`,
          params: {
            start_timestamp: queryArg.startTimestamp,
            end_timestamp: queryArg.endTimestamp,
            aggregate_frequency: queryArg.aggregateFrequency,
            unit_ids: queryArg.unitIds,
            timezone: queryArg.timezone,
          },
        }),
        providesTags: ['Basic Energy - Data'],
      }),
      energyTimestampsSummaryEnergyTimestampsSummaryAccountIdEnergyGroupIdGet:
        build.query<
          EnergyTimestampsSummaryEnergyTimestampsSummaryAccountIdEnergyGroupIdGetApiResponse,
          EnergyTimestampsSummaryEnergyTimestampsSummaryAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/energy_timestamps_summary/${queryArg.accountId}/${queryArg.energyGroupId}`,
          }),
          providesTags: ['Energy Data'],
        }),
      energyTimestampsSummaryAllEnergyTimestampsSummaryAllAccountIdEnergyGroupIdGet:
        build.query<
          EnergyTimestampsSummaryAllEnergyTimestampsSummaryAllAccountIdEnergyGroupIdGetApiResponse,
          EnergyTimestampsSummaryAllEnergyTimestampsSummaryAllAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/energy_timestamps_summary_all/${queryArg.accountId}/${queryArg.energyGroupId}`,
          }),
          providesTags: ['Energy Data'],
        }),
      energyOverviewEnergyOverviewAccountIdEnergyGroupIdGet: build.query<
        EnergyOverviewEnergyOverviewAccountIdEnergyGroupIdGetApiResponse,
        EnergyOverviewEnergyOverviewAccountIdEnergyGroupIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/energy_overview/${queryArg.accountId}/${queryArg.energyGroupId}`,
          params: {
            start_timestamp: queryArg.startTimestamp,
            end_timestamp: queryArg.endTimestamp,
          },
        }),
        providesTags: ['Energy Data'],
      }),
      extractEnergyDataEnergyDataAccountIdEnergyGroupIdGet: build.query<
        ExtractEnergyDataEnergyDataAccountIdEnergyGroupIdGetApiResponse,
        ExtractEnergyDataEnergyDataAccountIdEnergyGroupIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/energy_data/${queryArg.accountId}/${queryArg.energyGroupId}`,
          params: {
            start_timestamp: queryArg.startTimestamp,
            end_timestamp: queryArg.endTimestamp,
            active_period_filter: queryArg.activePeriodFilter,
            holidays_filter: queryArg.holidaysFilter,
          },
        }),
        providesTags: ['Energy Data'],
      }),
      energyDataSpecificEnergyDataSpecificAccountIdEnergyGroupIdGet:
        build.query<
          EnergyDataSpecificEnergyDataSpecificAccountIdEnergyGroupIdGetApiResponse,
          EnergyDataSpecificEnergyDataSpecificAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/energy_data_specific/${queryArg.accountId}/${queryArg.energyGroupId}`,
            params: {
              start_timestamp: queryArg.startTimestamp,
              end_timestamp: queryArg.endTimestamp,
              node_ids: queryArg.nodeIds,
            },
          }),
          providesTags: ['Energy Data'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as energyAnalysisOpenApi };
export type ExtractDataBasicEnergyDataAnalysisTypeAccountIdGetApiResponse =
  /** status 200 Successful Response */ BasicEnergyDataOutput;
export type ExtractDataBasicEnergyDataAnalysisTypeAccountIdGetApiArg = {
  /** The analysis type: 'power', 'heat', or 'water'. */
  analysisType: string;
  /** The account id to get data for. */
  accountId: number;
  /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  startTimestamp: string;
  /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  endTimestamp: string;
  /** The frequency to aggregate the data: 'hour', 'day', 'week', 'month', or 'year'. */
  aggregateFrequency: string;
  /** List of unit IDs to aggregate in the output. If empty or None, all units are selected. */
  unitIds?: number[] | null;
  /** The timezone to use for aggregations. Default is 'Europe/Copenhagen'. */
  timezone?: string;
};
export type EnergyTimestampsSummaryEnergyTimestampsSummaryAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ TimestampsSummaryModel;
export type EnergyTimestampsSummaryEnergyTimestampsSummaryAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the energy timestamps summary for. */
    energyGroupId: number;
    /** The account id to get the energy timestamps summary for. */
    accountId: number;
  };
export type EnergyTimestampsSummaryAllEnergyTimestampsSummaryAllAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ NodeTimestampsSummaryOutput[];
export type EnergyTimestampsSummaryAllEnergyTimestampsSummaryAllAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get all node timestamp summaries for. */
    energyGroupId: number;
    /** The account id to get all node timestamp summaries for. */
    accountId: number;
  };
export type EnergyOverviewEnergyOverviewAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ EnergyOverviewOutput;
export type EnergyOverviewEnergyOverviewAccountIdEnergyGroupIdGetApiArg = {
  /** The energy group id to get the energy overview for. */
  energyGroupId: number;
  /** The account id to get the energy overview for. */
  accountId: number;
  /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  startTimestamp: string;
  /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  endTimestamp: string;
};
export type ExtractEnergyDataEnergyDataAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ EnergyGroupDataOutput;
export type ExtractEnergyDataEnergyDataAccountIdEnergyGroupIdGetApiArg = {
  /** The energy group id to get the energy overview for. */
  energyGroupId: number;
  /** The account id to get the energy overview for. */
  accountId: number;
  /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  startTimestamp: string;
  /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  endTimestamp: string;
  /** Filter data points based on opening hours. If True, keep only data within opening hours (active period). If False, keep only data outside opening hours (inactive period). If None, no filtering is applied. */
  activePeriodFilter?: boolean | null;
  /** Filter out data points where the timestamp is not on a holiday if True. If False the data points on a holiday will be filtered out. If None no filtering will be done. */
  holidaysFilter?: boolean | null;
};
export type EnergyDataSpecificEnergyDataSpecificAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ EnergyDataOutput;
export type EnergyDataSpecificEnergyDataSpecificAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the energy overview for. */
    energyGroupId: number;
    /** The account id to get the energy overview for. */
    accountId: number;
    /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    startTimestamp: string;
    /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    endTimestamp: string;
    /** List of node ids to get the energy data for. If empty, energy data for all nodes will be returned. */
    nodeIds: string[];
  };
export type AggregatedEnergyDataPoint = {
  /** The timestamp of the data point. Format: YYYY-MM-DDTHH:MM:SSZ */
  timestamp: string;
  /** The sum of the data points in kWh. */
  sum: number;
  /** The mean of the data points in kWh. */
  mean: number;
  /** The min of the data points in kWh. */
  min: number;
  /** The max of the data points in kWh. */
  max: number;
};
export type MeterDataPoint = {
  /** The timestamp of the data point. Format: YYYY-MM-DDTHH:MM:SSZ */
  timestamp: string;
  /** The sum of the values in the aggregation period in kWh. */
  sum: number;
  /** The mean of the values in the aggregation period in kWh. */
  mean: number;
  /** The minimum value in the aggregation period in kWh. */
  min: number;
  /** The maximum value in the aggregation period in kWh. */
  max: number;
};
export type MeterTimeSeries = {
  /** The unit ID of the meter. */
  UnitId: number;
  /** The name of the meter (used for chart legend). */
  UnitName: string;
  /** The data type (e.g., 'power-consumption', 'heat-consumption'). */
  DataType: string;
  /** Time series data points for this meter, sorted by timestamp. */
  DataPoints?: MeterDataPoint[];
};
export type MeterSummary = {
  /** The unit id. */
  UnitId: number;
  /** The unit name. */
  UnitName: string;
  /** The unit type input id. */
  UnitTypeInputId: number;
  /** The aggregate type (e.g., 'Hour'). */
  AggregateType: string;
  /** The data type (e.g., 'power-consumption'). */
  DataType: string;
  /** The total value of the data. */
  TotalValue: number;
  /** The min value of the data. */
  MinValue: number;
  /** The max value of the data. */
  MaxValue: number;
  /** The average value of the data. */
  MeanValue: number;
  /** The median of the data. */
  MedianValue: number;
  /** The first quartile of the data. */
  Q1Value: number;
  /** The third quartile of the data. */
  Q3Value: number;
  /** The latest timestamp of data. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  LatestTimestamp: string;
  /** The earliest timestamp of data. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  EarliestTimestamp: string;
};
export type TimestampsSummaryModel = {
  /** The minimum earliest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  minEarliestDataTimestamp: string | null;
  /** The maximum earliest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  maxEarliestDataTimestamp: string | null;
  /** The minimum latest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  minLatestDataTimestamp: string | null;
  /** The maximum latest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  maxLatestDataTimestamp: string | null;
};
export type ApiWarning = {
  /** The warning message */
  message: string;
  /** The warning type */
  warning_type: string;
  /** The warning details */
  details?: object;
};
export type BasicEnergyDataOutput = {
  /** The account id. */
  AccountId: number;
  /** The aggregated energy data points (sum of all selected meters). */
  AggregatedData?: AggregatedEnergyDataPoint[];
  /** Per-meter time series data for stacked chart visualization. */
  StackedData?: MeterTimeSeries[];
  /** The meter summaries. */
  MeterSummaries?: MeterSummary[];
  /** The timestamp summary. */
  TimestampsSummary: TimestampsSummaryModel;
  Warnings?: ApiWarning[];
  /** The timestamp when the data was last cached. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  LastCacheTimestamp?: string | null;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type NodeTimestampsSummaryOutput = {
  /** The id of the energy tree node. */
  energyTreeNodeId: string;
  /** Timestamp summary for the specific node. */
  timestampsSummary: TimestampsSummaryModel;
};
export type EnergyDataPoint = {
  /** The timestamp of the data point. Format: YYYY-MM-DDTHH:MM:SSZ */
  timestamp: string;
  /** The value of the data point in kWh. */
  value: number | null;
};
export type EnergyDataSummaryModel = {
  /** The total energy usage in kWh. */
  TotalEnergyUsage: number;
  /** The average energy usage in kWh. */
  AverageEnergyUsage: number;
  /** The max energy usage in kWh. */
  MaxEnergyUsage: number;
  /** The min energy usage in kWh. */
  MinEnergyUsage: number;
  /** The total measured energy in kWh. Only available if the energy data is measured data. */
  TotalMeasuredEnergy?: number | null;
  /** The percentage of measured energy compared to the total energy usage. Only available if the energy data is measured data. */
  MeasuredEnergyPercentage?: number | null;
  /** The start timestamp of the energy data. Format: YYYY-MM-DDTHH:MM:SSZ */
  StartTimestamp: string;
  /** The end timestamp of the energy data. Format: YYYY-MM-DDTHH:MM:SSZ */
  EndTimestamp: string;
  /** The base unit for the energy data. */
  BaseUnit?: string;
};
export type DistributionBoardSummaryModel = {
  /** The node name of the distribution board. */
  Name: string;
  /** The node id of the distribution board. */
  Id: string;
  /** The total energy usage in kWh. */
  TotalEnergyUsage: number;
  /** The average energy usage in kWh. */
  AverageEnergyUsage: number;
  /** The max energy usage in kWh. */
  MaxEnergyUsage: number;
  /** The min energy usage in kWh. */
  MinEnergyUsage: number;
  /** The energy usage of the child nodes in kWh. */
  ChildEnergyUsage: number;
  /** The energy usage of the child nodes in percentage. */
  ChildEnergyUsagePercentage: number;
  /** The remaining energy usage not analysed in kWh. TotalEnergyUsage - ChildEnergyUsage. */
  NotAnalysedEnergyUsage: number;
  /** The remaining energy usage not analysed in percentage. TotalEnergyUsage - ChildEnergyUsage. */
  NotAnalysedEnergyUsagePercentage: number;
  /** Gives information about in what ranges the data is present. */
  TimestampsSummary: TimestampsSummaryModel;
};
export type DistributionBoardOverviewModel = {
  /** The main distribution board. */
  MainDistributionBoard: DistributionBoardSummaryModel;
  /** The sub distribution boards. */
  SubDistributionBoards?: DistributionBoardSummaryModel[];
};
export type MainMeterBoardOverviewModel = {
  /** The main meter. */
  MainMeter: DistributionBoardSummaryModel;
  /** The distribution boards with sub distribution boards. */
  SubMeters?: DistributionBoardOverviewModel[];
};
export type EnergyDistributionSummaryModel = {
  /** The name of the Significant Energy User (SEU) type. */
  Name: string;
  /** The total energy usage in kWh. */
  TotalEnergyUsage: number;
  /** The average energy usage in kWh. */
  AverageEnergyUsage: number;
  /** The max energy usage in kWh. */
  MaxEnergyUsage: number;
  /** The min energy usage in kWh. */
  MinEnergyUsage: number;
  /** The energy contribution in percentage compared to the total energy usage. */
  EnergyContributionPercentage: number | null;
  /** Gives information about in what ranges the data is present. */
  TimestampsSummary: TimestampsSummaryModel;
};
export type EnergyOverviewOutput = {
  /** The energy data. */
  EnergyData: EnergyDataPoint[];
  /** The energy distribution data. */
  EnergyDistributionData: object[];
  /** The energy data summary. */
  EnergyDataSummary: EnergyDataSummaryModel;
  /** Gives information about in what ranges the data is present. */
  TimestampsSummary: TimestampsSummaryModel;
  /** The main meter setup type: 'virtual_main_meter', 'data_main_meter', or 'main_meter_segregation'. */
  MainMeterSetup: string;
  /** The distribution boards summary or main meter boards summary.Returns main meter boards summary if the energy tree has a main meter segregation setup. */
  DistributionBoardsSummary:
    DistributionBoardOverviewModel[] | MainMeterBoardOverviewModel[];
  /** The energy distribution summary. */
  EnergyDistributionSummary: EnergyDistributionSummaryModel[];
  Warnings?: ApiWarning[];
};
export type EnergySummaryModel = {
  /** The id of the entity. */
  Id?: number | string | null;
  /** The name of the entity. */
  Name: string;
  /** The total energy usage in kWh. Null if openingHours is not configured and filtering is requested. */
  TotalEnergyUsage?: number | null;
  /** The average energy usage in kWh. Null if openingHours is not configured and filtering is requested. */
  AverageEnergyUsage?: number | null;
  /** The max energy usage in kWh. Null if openingHours is not configured and filtering is requested. */
  MaxEnergyUsage?: number | null;
  /** The min energy usage in kWh. Null if openingHours is not configured and filtering is requested. */
  MinEnergyUsage?: number | null;
  /** The analysed energy usage in kWh. */
  AnalysedEnergyUsage?: number | null;
  /** The analysed energy usage in percentage. */
  AnalysedEnergyUsagePercentage?: number | null;
  /** The remaining energy usage not analysed in kWh. */
  NotAnalysedEnergyUsage?: number | null;
  /** The remaining energy usage not analysed in percentage. */
  NotAnalysedEnergyUsagePercentage?: number | null;
  /** The timestamp summary. */
  TimestampsSummary: TimestampsSummaryModel;
};
export type EnergyGroupDataOutput = {
  /** The Id of the energy group. */
  Id: number;
  /** The name of the energy group. */
  Name: string;
  /** The node energy summaries. */
  NodeEnergySummaries: EnergySummaryModel[];
  /** The timestamp summary. */
  TimestampsSummary: TimestampsSummaryModel;
  Warnings?: ApiWarning[];
};
export type EnergyDataOutput = {
  /** The energy summary of the entity. */
  EnergySummary: EnergySummaryModel;
  /** The energy data as a time series for the entity. */
  EnergyData: AggregatedEnergyDataPoint[];
  Warnings?: ApiWarning[];
};
export const {
  useExtractDataBasicEnergyDataAnalysisTypeAccountIdGetQuery,
  useEnergyTimestampsSummaryEnergyTimestampsSummaryAccountIdEnergyGroupIdGetQuery,
  useEnergyTimestampsSummaryAllEnergyTimestampsSummaryAllAccountIdEnergyGroupIdGetQuery,
  useEnergyOverviewEnergyOverviewAccountIdEnergyGroupIdGetQuery,
  useExtractEnergyDataEnergyDataAccountIdEnergyGroupIdGetQuery,
  useEnergyDataSpecificEnergyDataSpecificAccountIdEnergyGroupIdGetQuery,
} = injectedRtkApi;
